import styled from 'styled-components';
import { secondaryFont } from 'components/mixins/typography';
import { transparentize } from 'utils/color';

export const RemainingAttemptsBlockText = styled.div`
  ${secondaryFont};
  display: block;
  font-size: 12px;
  margin-top: 8px;
  line-height: 1;
  color: ${props => transparentize(props.theme.colors.textColor, 0.7)};
  text-align: center;
`;
